import { render, staticRenderFns } from "./callback-renewal-orders.vue?vue&type=template&id=709038fc&scoped=true"
import script from "./callback-renewal-orders.vue?vue&type=script&lang=js"
export * from "./callback-renewal-orders.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "709038fc",
  null
  
)

export default component.exports